import {Inject, Injectable} from '@angular/core';
import {UserToken} from "../model/user.token";
import {jwtDecode} from "jwt-decode";
import {LOGIN_TOKEN} from "../tokens/tokens";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  isLoggedIn = false;
  redirectUrl: string | undefined;

  constructor(@Inject(LOGIN_TOKEN) private loginToken: string) {
  }

  getUser(): UserToken | null {
    let token = sessionStorage.getItem(this.loginToken);
    if (token) {
      return jwtDecode<UserToken>(token);
    }
    return null;
  }

  getUserStatus(): string | null {
    const token: string | null = sessionStorage.getItem(this.loginToken); // Or use sessionStorage or cookies
    if (token) {
      const decodedToken: any = jwtDecode<UserToken>(token);
      return decodedToken.status;
    }
    return null;
  }

  getUserIdFromToken(): string | null {
    const token: string | null = sessionStorage.getItem(this.loginToken); // Or use sessionStorage or cookies
    if (token) {
      const decodedToken: any = jwtDecode<UserToken>(token);
      return decodedToken.id;
    }
    return null;
  }

  getPhoneNumberFromToken(): string | null {
    const token: string | null = sessionStorage.getItem(this.loginToken); // Or use sessionStorage or cookies
    if (token) {
      const decodedToken: any = jwtDecode<UserToken>(token);
      return decodedToken.phone;
    }
    return null;
  }

  getEmailFromToken(): string | null {
    const token: string | null = sessionStorage.getItem(this.loginToken); // Or use sessionStorage or cookies
    if (token) {
      const decodedToken: any = jwtDecode<UserToken>(token);
      return decodedToken.email;
    }
    return null;
  }

  logout() {
    sessionStorage.removeItem(this.loginToken);
  }

  isInternalUser(): boolean {
    let token = sessionStorage.getItem(this.loginToken);
    if (token) {
      let payload = jwtDecode<UserToken>(token);
      if (payload?.internal === true) {
        return true;
      }
    }
    return false;
  }

  public getUserRoles(): string[] {
    const token = sessionStorage.getItem(this.loginToken);
    if (token) {
      const decoded: any = jwtDecode<UserToken>(token);
      return decoded.roles || [];
    }
    return [];
  }

  hasRole(role: string): boolean {
    let roles = this.getUserRoles();
    return roles.includes(role);
  }

  getAuthorities(): string[] {
    const token = sessionStorage.getItem(this.loginToken);
    if (token) {
      const decoded: any = jwtDecode<UserToken>(token);
      return decoded.authorities || [];
    }
    return [];
  }

  hasAuthority(requiredAuthority: string): boolean {
    const authorities = this.getAuthorities();
    return authorities.includes(requiredAuthority);
  }

  checkLogin(): boolean {
    if (this.getUserIdFromToken() == null) {
      return this.isLoggedIn = false;
    }
    return this.isLoggedIn = true;
  }

  login() {
    this.isLoggedIn = true;
  }

  clearToken(): void {
    sessionStorage.removeItem(this.loginToken);
  }

  isTokenExpired(): boolean {
    let token = sessionStorage.getItem(this.loginToken);
    if (!token) return true;
    try {
      let payload = jwtDecode<UserToken>(token);
      return payload.exp * 1000 < Date.now();
    } catch (e) {
      return true;
    }
  }
}
